import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { ComponentProps } from 'react';

import { FaIconLite } from './fa-icon-lite';

export function FaIconCircleInfo(props: ComponentProps<'svg'>) {
  return <FaIconLite icon={faCircleInfo} className={props.className} />;
}
